const privacyContent = {
    title: {
        en: "Privacy Policy – AppSinTi Dev, LLC",
        es: "Política de Privacidad – AppSinTi Dev, LLC"
    },
    effectiveDate: {
        en: "Effective Date:",
        es: "Fecha Efectiva:"
    },
    date: {
        en: "May 20, 2025",
        es: "20 de mayo de 2025"
    },
    introduction: {
        en: `AppSinTi Dev, LLC ("we," "our," or "us") provides software-as-a-service (SaaS) solutions for restaurants, including administrative tools, monitoring applications, survey systems, reservation interfaces, and online menus. This Privacy Policy explains how we collect, use, and protect information across our services.`,
        es: `AppSinTi Dev, LLC ("nosotros", "nuestro") provee soluciones de software como servicio (SaaS) para restaurantes, incluyendo herramientas administrativas, aplicaciones de monitoreo, sistemas de encuestas, interfaces de reservaciones y menús en línea. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos la información en nuestros servicios.`
    },
    infoCollectedTitle: {
        en: "Information We Collect",
        es: "Información que Recopilamos"
    },
    infoCollectedBusinessTitle: {
        en: "From Business Users (B2B Clients)",
        es: "De Usuarios Empresariales (Clientes B2B)"
    },
    infoCollectedUsersTitle: {
        en: "From End Users (e.g., Survey Participants)",
        es: "De Usuarios Finales (p. ej., Participantes de Encuestas)"
    },
    infoCollectedBusiness: {
        en: "Contact and account information (name, email, company, role), Usage logs and admin panel activity, Payment and billing details (if applicable)",
        es: "Información de contacto y cuenta (nombre, correo, empresa, rol), Registros de uso y actividad del panel administrativo, Detalles de pago y facturación (si es aplicable)"
    },
    infoCollectedEnd: {
        en: "Optional contact details (email address, phone number), Survey responses, Device and browser information",
        es: "Detalles de contacto opcionales (dirección de correo, número de teléfono), Respuestas de encuestas, Información del dispositivo y navegador"
    },
    howWeUse: {
        en: "Provide and improve our services, Customer support, Analytics and performance tracking, Communication (including marketing messages where permitted), Legal compliance and fraud prevention",
        es: "Proveer y mejorar nuestros servicios, Soporte al cliente, Analítica y seguimiento del rendimiento, Comunicación (incluyendo mensajes de marketing cuando sea permitido), Cumplimiento legal y prevención de fraude"
    },
    sharingInfo: {
        en: "Service providers (e.g., Toast, OpenTable, analytics and hosting platforms), Legal authorities if required, Our affiliated restaurant clients (e.g., survey results or reservations data). We do not sell personal information to third parties.",
        es: "Proveedores de servicios (p.ej., Toast, OpenTable, plataformas de analítica y hosting), autoridades legales si es requerido, Nuestros clientes afiliados (p.ej., resultados de encuestas o datos de reservaciones). No vendemos información personal a terceros."
    },
    cookiesTracking: {
        en: "We use cookies and similar technologies for user authentication, preferences, and analytics. You can manage cookies via your browser settings.",
        es: "Usamos cookies y tecnologías similares para la autenticación de usuarios, preferencias y analítica. Puede gestionar las cookies mediante la configuración de su navegador."
    },
    rightsAndChoices: {
        en: "Depending on your jurisdiction, you may have rights to: Access, correct, or delete your data, Opt out of marketing communications, Withdraw consent for SMS/email.",
        es: "Dependiendo de su jurisdicción, puede tener derechos para: Acceder, corregir o eliminar sus datos, Oponerse a comunicaciones de marketing, Retirar su consentimiento para SMS/correo electrónico."
    },
    rightsInMexico: {
        en: `Individuals located in Mexico have the right to access, rectify, cancel, or oppose the use of their personal data (known as "ARCO" rights), and may exercise these rights by contacting us at `,
        es: `Las personas ubicadas en México tienen derecho a acceder, rectificar, cancelar u oponerse al uso de sus datos personales (conocidos como derechos "ARCO"), y pueden ejercer estos derechos contactándonos en `
    },
    securityMeasures: {
        en: "We implement reasonable administrative, technical, and physical safeguards to protect your data.",
        es: "Implementamos salvaguardas administrativas, técnicas y físicas razonables para proteger sus datos."
    },
    dataRetention: {
        en: "We retain personal data for as long as necessary to fulfill the purposes described above, or as required by law.",
        es: "Conservamos los datos personales durante el tiempo necesario para cumplir los fines anteriores, o según lo requiera la ley."
    },
    internationalTransfers: {
        en: "If you are accessing our services from Mexico or other countries outside the United States, your information may be transferred to, stored, and processed in the United States. We take reasonable measures to ensure that such transfers comply with applicable Mexican privacy laws (LFPDPPP) and include mechanisms to protect your data appropriately.",
        es: "Si accede a nuestros servicios desde México u otros países fuera de los Estados Unidos, su información puede ser transferida, almacenada y procesada en los Estados Unidos. Tomamos medidas razonables para asegurar que dichas transferencias cumplan con las leyes de privacidad mexicanas (LFPDPPP) e incluyan mecanismos apropiados para proteger sus datos."
    },
    childrensPrivacy: {
        en: "Our services are not intended for children under 13. We do not knowingly collect data from children.",
        es: "Nuestros servicios no están destinados a niños menores de 13 años. No recopilamos datos de niños de forma consciente."
    },
    contactUs: {
        en: "For questions about this policy or our data practices, contact us at ",
        es: "Para preguntas sobre esta política o nuestras prácticas de datos, contáctenos en "
    }
};

export default privacyContent;